module.exports = __webpack_public_path__ + "img/read.20ea3c7f.svg";